import {SyntheticEvent} from 'react';
import {CURSOR_MARK, MarkedInput} from './types';

const subMarkWithCursor = (e: SyntheticEvent<HTMLInputElement>, input: MarkedInput): void => {
  let value = e.currentTarget.value;
  let cursorPosition = e.currentTarget.value.length;
  if (input.includes(CURSOR_MARK)) {
    cursorPosition = input.indexOf(CURSOR_MARK);
    value = input.filter(char => char !== CURSOR_MARK).join('');
  }
  // Change value before setting the selection,
  // otherwise selection resets
  e.currentTarget.value = value;
  (e.target as HTMLInputElement).value = value;
  e.currentTarget.setSelectionRange(cursorPosition, cursorPosition);
}

export default subMarkWithCursor;
